"use strict";

/**
 * @classdesc
 * Einstellungen-Modul
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {string} options.alias
 * @param {string} options.target
 * @param {gc.gis.map.GCMapView} [options.map=gc.gis.iface.map]
 * @param {string} [options.label='Ansichten']
 */
gc.gis.module.GCSettings = function( options )
{
	gc.gis.module.GCAbstractModule.call( this, options );

	this.options       = options;
	this.map           = options.map || gc.gis.iface.map;
	this.label         = options.label || 'Einstellungen';

	this._render();

	this.launcher = {
		label: this.label,
		icon: 'glyphicon glyphicon-cog',
		content: new gc.gis.ui.GCSidebarContent({
			label:   this.label,
			'parent': null,
			element: this.getElement()
		})
	};
	gc.gis.iface.ui.sidebar.addLauncher( this.launcher );
};
gc.gis.module.GCSettings.prototype = Object.create( gc.gis.module.GCAbstractModule.prototype );

/**
 *
 */
gc.gis.module.GCSettings.prototype.getElement = function()
{
	return this._element_panel.getElement();
};

/**
 *
 */
gc.gis.module.GCSettings.prototype._render = function()
{
	this._element_panel = new gc.gis.module.GCSettings.Panel({
		module: this
	});

	return this._element;
};
